import { PromptFiltersSkeleton } from "@1js/pl-card-components";
import {
  Skeleton,
  SkeletonItem,
  makeStyles,
  shorthands,
} from "@fluentui/react-components";
import * as React from "react";
import { useIsSmallScreen } from "../../hooks/useIsSmallScreen";

const useStyles = makeStyles({
  root: {
    display: "flex",
    flexDirection: "row",
    ...shorthands.gap("16px"),
  },

  mobileSkeleton: {
    minWidth: "96px",
  },
});

export const FiltersSkeleton: React.FC = () => {
  const isMobile = useIsSmallScreen();
  const styles = useStyles();

  return (
    <>
      {!isMobile && (
        <div className={styles.root}>
          <PromptFiltersSkeleton />
          <PromptFiltersSkeleton />
        </div>
      )}
      {isMobile && (
        <Skeleton>
          <SkeletonItem className={styles.mobileSkeleton} size={32} />
        </Skeleton>
      )}
    </>
  );
};
FiltersSkeleton.displayName = "AllPromptsFiltersSkeleton";
